// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__gzvUK","SectionContact":"Footer_SectionContact__LX5Qz","ContactContent":"Footer_ContactContent__dtSnI","SectionLinks":"Footer_SectionLinks__Yv87W"};